<template>
  <div>
    <div class="search-wrapper">
      <div class="search">
        <span>地区：</span>
        <Select
          v-model="searchValue.area"
          :style="{ width:'120px', marginRight: '5px' }"
          @on-change="getArea"
        >
          <Option
            v-for="depart in areaArr"
            :key="depart.id"
            :value="depart.name"
          >{{depart.name}}</Option>
        </Select>
        <span>分/子公司：</span>
        <Select
          v-model="searchValue.childcompany"
          style="width: 250px;margin-right:5px;"
        >
          <Option
            v-for="company in childCompanies"
            :key="company.id"
            :value="company.cName"
          >{{company.cName}}</Option>
        </Select>
        <span>项目简编：</span>
        <Input
          style="width:120px;margin-right:10px;"
          type="text"
          v-model="searchValue.projectShort"
        ></Input>
        <span>项目编号：</span>
        <Input
          style="width:150px;"
          v-model="searchValue.projectFull"
        ></Input>
        <span>项目名称：</span>
        <Input
          style="width:200px;margin-right:10px;"
          type="text"
          v-model="searchValue.projectName"
        ></Input>
      </div>
      <Button
        type="primary"
        style="margin: 0 10px 0 10px;"
        @click="search"
      >搜索</Button>
    </div>
    <Table
      :columns="columns"
      :data="dataList"
      style="min-width:1200px;"
    ></Table>
    <Page
      ref="page"
      :current="currentPage"
      style="margin-top:10px;"
      :total="total"
      show-elevator
      show-total
      @on-change="changePage"
    ></Page>
    <!-- 发放登记 -->
    <Modal title="发放登记" v-model="showSheet" id="peopleDialog" width="580">
      <Form ref="form" :model="form" :rules="rules">
        <Row>
          <FormItem label="请选择:" :label-width="72">
            <Checkbox v-model="form.choiceWinBidNotice" @on-change="cacelSelected($event, 0)">中标通知书</Checkbox>
          </FormItem>
          <template v-if="form.choiceWinBidNotice">
            <Col span="12">
              <FormItem label="发放方式:" prop="wbnType" required>
                <Select v-model="form.wbnType" style="width:160px">
                  <Option v-for="type in ['邮寄快递','现场提交']" :key="type" :value="type">{{type}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12" v-if="form.wbnType==='邮寄快递'">
              <FormItem label="快递单号:" prop="wbnCourierNumber" required>
                <Input v-model="form.wbnCourierNumber" placeholder="请输入快递单号" style="width:160px"></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="档案人员:" prop="wbnFilePerson" required>
                <Input v-model="form.wbnFilePerson" style="width:160px"></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="发放日期:" prop="wbnSendDate" required>
                <DatePicker type="date" style="width:160px" v-model="form.wbnSendDate"></DatePicker>
              </FormItem>
            </Col>
            <Col span="24" style="margin-left:34px">
              <FormItem label="备注:">
                <Input v-model="form.wbnRemark" style="width:440px"></Input>
              </FormItem>
            </Col>
          </template>
        </Row>
        <Row>
          <FormItem label="请选择:" :label-width="72">
            <Checkbox v-model="form.choiceChargesInvoice" @on-change="cacelSelected($event, 1)">服务费发票</Checkbox>
          </FormItem>
          <template v-if="form.choiceChargesInvoice">
            <Col span="12">
              <FormItem label="发放方式:" prop="ciType" required>
                <Select v-model="form.ciType" style="width:160px">
                  <Option v-for="type in ['邮寄快递','现场提交']" :key="type" :value="type">{{type}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12" v-if="form.ciType==='邮寄快递'">
              <FormItem label="快递单号:" prop="ciCourierNumber" required>
                <Input v-model="form.ciCourierNumber" placeholder="请输入快递单号" style="width:160px"></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="档案人员:" prop="ciFilePerson" required>
                <Input v-model="form.ciFilePerson" style="width:160px"></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="发放日期:" prop="ciSendDate" required>
                <DatePicker type="date" style="width:160px" v-model="form.ciSendDate"></DatePicker>
              </FormItem>
            </Col>
            <Col span="24" style="margin-left:34px">
              <FormItem label="备注:">
                <Input v-model="form.ciRemark" style="width:440px"></Input>
              </FormItem>
            </Col>
          </template>
        </Row>
      </Form>
			<div slot="footer" style="text-align:center">
        <Button @click="submit" type="primary">提交</Button>
        <Button @click="showSheet=false">取消</Button>
      </div>
		</Modal>
    <!-- 邮件通知 -->
    <Modal v-model="showEmail" title="邮件通知">
      <Row>
        <Col span="4" style="text-align:right">项目名称：</Col>
        <Col span="17" class="modal-value">
            {{ currentData.projectName }}
        </Col>
      </Row>
      <Row style="margin-top:10px">
        <Col span="4" style="text-align:right">中标单位：</Col>
        <Col span="17" class="modal-value">
            {{ currentData.winCompany }}
        </Col>
      </Row>
      <Row style="margin-top:10px">
        <Col span="4" style="text-align:right">应收服务费：</Col>
        <Col span="17" class="modal-value">
            {{ currentData.chargeAmount }}
        </Col>
      </Row>
      <Row style="margin-top:10px">
        <Col span="4" style="text-align:right;line-height:32px">
          <span style="color:red">*</span>通知邮箱：
        </Col>
        <Col span="17" class="modal-value">
          <Input v-model="toEmail"></Input>
        </Col>
      </Row>
      <Row style="margin-top:10px">
        <Col span="4" style="text-align:right;line-height:32px">
          <span style="color:red">*</span>邮件标题：
        </Col>
        <Col span="17" class="modal-value">
          <Input v-model="emailTitle"></Input>
        </Col>
      </Row>
      <Row style="margin-top:10px">
        <Col span="4" style="text-align:right;line-height:32px">
          <span style="color:red">*</span>通知内容：
        </Col>
        <Col span="17" class="modal-value">
          <Input type="textarea" v-model="emailContent"></Input>
        </Col>
      </Row>
      <div slot="footer" style="text-align:center">
        <Button @click="showEmail=false">取消</Button>
        <Button @click="sendEmail" type="primary">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '../../lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { formatDate } from '@/lib/tool'
import sendMessage from "@/lib/message"
import Axios from 'axios'

export default {
  data() {
    return {
      dataList: [],
      columns: [
        {
          title: '分公司',
          key: 'district',
          width: 80,
        },
        {
          title: '项目名称',
          key: 'projectName'
        },
        {
          title: '项目编号',
          width: 150,
          align: 'center',
          key: 'projectFull'
        },
        {
          title: '包组/标段',
          key: 'groupName'
          // width: 60,
        },
        {
          title: '中标供应商',
          key: 'winCompany'
        },
        {
          title: '服务费状态',
          width: 100,
          align: 'center',
          key: 'chargeStatus'
        },
        {
          title: '资料',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return [
              h('div', '中标通知书'),
              h('div', '服务费发票')
            ]
          }
        },
        {
          title: '发放状态',
          width: 90,
          render: (h, params) => {
            return [
              h('div', params.row.record && params.row.record.wbnSendDate ? '已发放' : '未发放'),
              h('div', params.row.record && params.row.record.ciSendDate ? '已发放' : '未发放'),
            ]
          }
        },
        {
          title: '发放日期',
          align: 'center',
          width: 110,
          render: (h, params) => {
            return [
              h('div', params.row.record && params.row.record.wbnSendDate ? formatDate(params.row.record.wbnSendDate).slice(0,10) : '/'),
              h('div', params.row.record && params.row.record.ciSendDate ? formatDate(params.row.record.ciSendDate).slice(0,10) : '/'),
            ]
          }
        },
        {
          title: '操作',
          width: 180,
          render: (h, params) => {
            return [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    if (params.row.record) {
                      this.form = params.row.record
                    } else {
                      this.form.projectId = params.row.projectId
                      this.form.groupId = params.row.groupId
                      this.form.companyName = params.row.winCompany
                    }
                    this.showSheet = true
                  }
                }
              }, '发放登记'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    if (params.row.record) {
                      this.form = params.row.record
                    } else {
                      this.form.projectId = params.row.projectId
                      this.form.groupId = params.row.groupId
                      this.form.companyName = params.row.winCompany
                    }
                    // 获取服务费信息
                    this.showEmail = true
                    this.currentData = params.row
                    this.emailTitle = `${params.row.projectName} 缴纳服务费提醒`
                  }
                }
              }, '邮件通知')
            ]
          }
        }
      ],
      currentPage: 1,
      total: 0,
      searchValue: {
        area: '',
        childcompany: '',
        projectFull: '',
        projectShort: '',
        projectName: ''
      },
      serviceVisible: false,
      childCompanies: [],
      areaArr: [],
      showSheet: false,
      form: {
        // "id": 0,
        "projectId": '',
        "groupId": '',
        "choiceWinBidNotice": false,
        "wbnType": "",
        "wbnCourierNumber": "",
        "wbnFilePerson": "",
        "wbnSendDate": "",
        "wbnRemark": "",
        "choiceChargesInvoice": false,
        "ciType": "",
        "ciCourierNumber": "",
        "ciFilePerson": "",
        "ciSendDate": "",
        "ciRemark": "",
        "companyName": '',
        "mailNoticeDate": ''
      },
      rules: {
        wbnType: [
          { required: true, trigger: 'blur', message: '发放方式不能为空' }
        ],
        wbnCourierNumber: [
          { required: true, trigger: 'blur', message: '快递单号不能为空' }
        ],
        wbnFilePerson: [
          { required: true, trigger: 'blur', message: '档案人员不能为空' }
        ],
        wbnSendDate: [
          { required: true, trigger: 'blur', message: '发放日期不能为空', type: 'date' }
        ],
        ciType: [
          { required: true, trigger: 'blur', message: '发放方式不能为空' }
        ],
        ciCourierNumber: [
          { required: true, trigger: 'blur', message: '快递单号不能为空' }
        ],
        ciFilePerson: [
          { required: true, trigger: 'blur', message: '档案人员不能为空' }
        ],
        ciSendDate: [
          { required: true, trigger: 'blur', message: '发放日期不能为空', type: 'date' }
        ]
      },
      showEmail: false,
      currentData: {},
      toEmail: '',
      emailTitle: '',
      emailContent: ''
    }
  },
  async created() {
    let rep = await ajax.get(requestUrls.CLDistrict.GetList)
    this.areaArr = []
    if (rep.data.success && rep.data.result.items.length > 0) {
      this.areaArr = rep.data.result.items
    }
    // 获取分子公司
    let childRep = await ajax.get(requestUrls.bankAccount.getAll)
    // 过滤重复数据
    let hadPush = []
    childRep.data.result.items.forEach(item => {
      if (hadPush.indexOf(item.cName) === -1) {
        hadPush.push(item.cName)
        this.childCompanies.push(item)
      }
    })
    this.childCompanies.push({
      id: 0,
      cName: '全部'
    })
    this.getList()
  },
  methods: {
    async getList(page= 1, queryObj = this.searchValue) {
      this.$Spin.show()
      this.currentPage = page
      let querySear = ''
      let searNum = queryObj.projectFull ? ` and p.projectFull.Contains("${queryObj.projectFull}")` : ''
      let searName = queryObj.projectName ? ` and p.projectName.Contains("${queryObj.projectName}")` : ''
      let searArea = (queryObj.area && queryObj.area !== '全部') ? ` and p.district.Contains("${queryObj.area}")` : ''
      let searNumArr = queryObj.projectShort ? ` and p.projectShort.Contains("${queryObj.projectShort}")` : ''
      let searChildCompany = (queryObj.childcompany && queryObj.childcompany !== '全部') ? ` and p.companyName.contains("${queryObj.childcompany}")` : ''
      querySear = querySear + searNum + searName + searArea + searNumArr  + searChildCompany
      let rep = await ajax.get(requestUrls.CLBidFileGrantRecord.GetProjectTablePaged, {
        params: {
          maxResultCount: 10,
          skipCount: (page - 1) * 10,
          filter: querySear.slice(5),
          sorting: 'p.newProjectTime desc'
        }
      })
      if (rep.data.success) {
        let projectIds = rep.data.result.items.map(item => {
          return item.projectId
        })
        if (!projectIds.length) {
          this.$Spin.hide()
          return
        }
        ajax.post(requestUrls.CLBidFileGrantRecord.PostListByProjectId, {
          projectIds: projectIds
        }).then(resp => {
          resp.data.result.items.forEach(item => {
            rep.data.result.items.forEach(project => {
              if (project.projectId === item.projectId && project.groupId === item.groupId && project.winCompany === item.companyName) {
                this.$set(project, 'record', item)
              }
            })
          })
          this.$Spin.hide()
          this.dataList = rep.data.result.items
          this.total = rep.data.result.totalCount
        })
      }
    },
    changePage(page) {
      this.getList(page)
    },
    search() {
      this.getList()
    },
    async getArea(district) {
      let filter = `district == "${district}"`
      let rep = await ajax.get(requestUrls.bankAccount.getAll, {
        params: {
          filter
        }
      })
      this.searchValue.childcompany = ''
      this.childCompanies = rep.data.result.items
      // 去重
      let map = new Map()
      this.childCompanies = this.childCompanies.filter(item => !map.has(item.cName) && map.set(item.cName, 1))
    },
    cacelSelected (e, type) {
      if (!e) { // 取消勾选
        if (type) { // 服务费发票
          this.form.ciType = ''
          this.form.ciCourierNumber = ''
          this.form.ciFilePerson = ''
          this.form.ciSendDate = ''
          this.form.ciRemark = ''
        } else { // 中标通知书
          this.form.wbnType = ''
          this.form.wbnCourierNumber = ''
          this.form.wbnFilePerson = ''
          this.form.wbnSendDate = ''
          this.form.wbnRemark = ''
        }
      }
    },
    submit () {
      this.$refs.form.validate((valid, e) => {
        if (valid) {
          console.log(this.form)
          this.$Spin.show()
          ajax.post(requestUrls.CLBidFileGrantRecord.CreateOrUpdate, {
            clBidFileGrantRecord: this.form
          }).then(res => {
            this.$Spin.hide()
            this.showSheet = false
            this.$refs.form.resetFields()
            this.getList(this.currentPage)
          })
        }
      })
    },
    sendEmail () {
      if (!this.toEmail || !this.emailTitle || !this.emailContent) {
        this.$Message.error('请完善邮箱信息！')
        return
      }
      // 邮件通知
      let typeParams = {
        title: this.emailTitle,
        toMail: this.toEmail,
        // toMail: 'yejiamin@choicelink.cn',
        content: this.emailContent
      }
      this.$Spin.show()
      sendMessage('emailContent', typeParams).then(res => {
        this.$Spin.hide()
        this.showEmail = false
        this.$Message.success('发送成功')
        // 记录邮件通知时间
        this.form.mailNoticeDate = formatDate()
        ajax.post(requestUrls.CLBidFileGrantRecord.CreateOrUpdate, {
          clBidFileGrantRecord: this.form
        }).then(() => {
          this.getList(this.currentPage)
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.search-wrapper {
  margin: 5px;
  .search {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
  }
}
</style>
